import { BioCardDirectoryProps } from '@ahc-digital/component-library';
import { useI18n } from 'next-localization';
import { getDroplink } from '@/shared/param-utils';
import { C55BiographyDirectoryProps } from './C55BiographyDirectory.types';
import { useConditionalRendering } from '@/shared/useConditionalRendering';

export function GetBiographyDirectoryModel(
  props?: C55BiographyDirectoryProps
): BioCardDirectoryProps {
  const { t } = useI18n() || {};
  const { fields, params } = props || {};
  const { renderText, renderRichText, renderImage, renderLink } = useConditionalRendering();

  const bios =
    fields?.Biographies?.map((bioItem) => {
      const { fields } = bioItem;

      return {
        additional: renderRichText(fields?.AdditionalInfo),
        displayName: renderText(fields?.DisplayName),
        email: renderText(fields?.Email),
        fax: renderText(fields?.Fax),
        image: renderImage(fields?.Image),
        locations: renderRichText(fields?.Locations),
        name: renderText(fields?.Name),
        optionalLink: renderLink(fields?.DetailedBioLink),
        phone: renderText(fields?.Phone),
        specialty: renderText(fields?.Specialty),
        title: renderText(fields?.Title),
      };
    }) || [];

  return {
    additionalInformationLabel: t('BioCard-AdditionalInformation'),
    bios: bios,
    emailLabel: t('BioCard-Email'),
    faxLabel: t('BioCard-Fax'),
    headline: renderText(fields?.Headline),
    headlineTag: getDroplink(params?.HeadlineTag, 'p'),
    locationsLabel: t('BioCard-Locations'),
    phoneLabel: t('BioCard-Phone'),
    specialtyLabel: t('BioCard-Specialty'),
    titleLabel: t('BioCard-Title'),
  };
}
